<template>
  <div class="page-shell page-shell--integral-benefits" v-permit="'Market.Payment.List'">
    <section class="page-shell__content">
      <div class="page-shell__panel">
        <public-table
          v-loading="listLoading"
          :column="column"
          :enableSearch="true"
          :searchItems="searchItems"
          :tableData="payments"
          :PageInfo="listQuery"
          @handlePaginationChange="getPaymentList"
          :is_table="true"
        >
          <template v-slot:createTime="{ row }">{{
            row.createTime ? timetrans(row.createTime) : '-'
          }}</template>
          <template v-slot:paymentType="{ row }">
            {{ showPaymentType(row.paymentType) }}
          </template>
          <template v-slot:price="{ row }">{{ row.price }}元</template>
          <template v-slot:balance="{ row }">{{ row.balance }}元</template>
        </public-table>
      </div>
    </section>
  </div>
</template>
<script>
import { timetrans } from '@/utils/validate';
import { fetchIntegralBenefits, fetchPaymentBusiness } from '@/api/myOrder';
import { errorHandle } from '@/utils/error';
import { havePerm } from '@/utils/auth';

const defaultListQuery = {
  page: 1,
  size: 10
};

export default {
  name: 'IntegralBenefits',
  components: {},
  data() {
    const paymentOptions = [
      {
        label: '充值',
        value: 'recharge'
      },
      {
        label: '消费',
        value: 'consumption'
      },
      {
        label: '收入',
        value: 'income'
      }
    ];
    return {
      paymentOptions: paymentOptions,
      customerForm: {
        type: 'all'
      },
      searchItems: [
        {
          label: '交易号',
          name: 'paymentID',
          value: '',
          span: 7,
          type: 'input'
        },
        {
          label: '订单号',
          name: 'orderID',
          value: '',
          span: 7,
          type: 'input'
        },
        {
          label: '交易时间',
          name: ['startTime', 'endTime'],
          type: 'timerange',
          span: 9,
          value: ''
        },
        {
          label: '交易类型',
          name: 'paymentType',
          value: '',
          type: 'select',
          span: 7,
          options: [
            {
              label: '全部',
              value: ''
            },
            {
              label: '收入',
              value: 'income'
            }
          ]
        },
        {
          label: '付款企业',
          name: 'payerEID',
          value: '',
          type: 'select',
          span: 7,
          options: []
        }
      ],
      listQuery: Object.assign({}, defaultListQuery),
      payments: [],
      listLoading: true,
      timetrans: timetrans,
      editCustomer: {},
      showEditCustomer: false,
      column: [
        {
          prop: 'paymentID',
          label: '交易号',
          fixed: 'left',
          width: '250px'
        },
        {
          prop: 'orderID',
          label: '订单号'
        },
        {
          prop: 'createTime',
          label: '交易时间',
          width: 150,
          scopeStatus: true
        },
        {
          prop: 'paymentType',
          label: '交易类型',
          width: 100,
          scopeStatus: true
        },

        {
          prop: 'payerEnt',
          label: '付款企业'
        },
        {
          prop: 'price',
          label: '金额',
          width: 100,
          scopeStatus: true
        },
        {
          prop: 'balance',
          label: '余额',
          width: 120,
          scopeStatus: true
        },
        {
          prop: 'note',
          label: '备注'
        }
      ]
    };
  },
  created() {
    if (havePerm('Market.Payment.List')) {
      this.getPaymentList();
      this.getPaymentBusiness();
    }
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    },
    sidebar() {
      return this.$store.state;
    }
  },
  methods: {
    showPaymentType(t) {
      let show = t;
      this.paymentOptions.map((item) => {
        if (item.value == t) {
          show = item.label;
        }
      });
      return show;
    },
    getPaymentList(param) {
      this.listLoading = true;
      if (param) {
        this.listQuery = Object.assign(this.listQuery, param);
      }
      fetchIntegralBenefits(
        Object.assign({}, this.listQuery, { marketID: this.marketID })
      )
        .then((re) => {
          this.payments = re.payments;
          this.listQuery.total = re.total;
          this.listLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.listLoading = false;
        });
    },
    getPaymentBusiness() {
      fetchPaymentBusiness({ marketID: this.marketID })
        .then((re) => {
          const arr =
            re && re.length > 0
              ? re.map((item) => {
                return { label: item.name, value: item.eid };
              })
              : [];
          arr.unshift({
            label: '全部',
            value: ''
          });
          this.searchItems.map((item) => {
            if (item.name === 'payerEID') {
              item.options = arr;
            }
          });
        })
        .catch((err) => {
          errorHandle(err);
        });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/page-shell.scss';
</style>



// WEBPACK FOOTER //
// src/views/storeManage/IntegralBenefits/index.vue